import { Injectable } from '@angular/core';
import { DataService } from './core/data.service';
import { TipoPesquisaProduto } from '../_common/enums';

@Injectable({ providedIn: 'root' })
export class ProdutoService extends DataService {
    context = 'produto';

    buscarProduto(termo: string, tipoDocumento: number, tipoPesquisa: TipoPesquisaProduto) {
        let params;
        switch (tipoPesquisa) {
            case TipoPesquisaProduto.cnae:
                params = { cnae: termo, tipoDocumento: tipoDocumento };
                break;
            case TipoPesquisaProduto.codigo:
                params = { codigoMaterial: termo, tipoDocumento: tipoDocumento };
                break;
            case TipoPesquisaProduto.descricao:
                params = { descricao: termo, tipoDocumento: tipoDocumento };
                break;
        }

        return this.getWithParams<any>(null, params);
    }

    buscarProdutoRecorrente(
        termo: string,
        tipoBusca: string,
        fornecedor: string,
        tipoDocumento: number,
        tipoPesquisa: TipoPesquisaProduto
    ) {
        let params;
        fornecedor = fornecedor || '';
        fornecedor = fornecedor.replace('.', '').replace('-', '').replace('/', '');

        switch (tipoPesquisa) {
            case TipoPesquisaProduto.cnae:
                params = { cnae: termo, tipoDocumento: tipoDocumento, tipoBusca: tipoBusca };
                break;
            case TipoPesquisaProduto.codigo:
                params = { codigoMaterial: termo, tipoDocumento: tipoDocumento, tipoBusca: tipoBusca };
                break;
            case TipoPesquisaProduto.descricao:
                params = { descricao: termo, tipoDocumento: tipoDocumento, tipoBusca: tipoBusca };
                break;
            default:
                params = { tipoDocumento: tipoDocumento, tipoBusca: tipoBusca };
                break;
        }

        return this.getWithParams<any>(`${fornecedor}/recorrentes`, params);
    }

    buscarProdutoMaterialRecorrente(_fornecedor: string
        , _tipoDocumento: number,
        _cnae: string,
        _tipoBusca: string,
        _descricao: string,
        _codigoMaterial: string) {
        let params;
        _fornecedor = _fornecedor || '';
        _fornecedor = _fornecedor.replace('.', '').replace('-', '').replace('/', '');

        params = {
            tipoDocumento: _tipoDocumento
            , cnae: _cnae
            , tipoBusca: _tipoBusca
            , descricao: _descricao
            , codigoMaterial: _codigoMaterial
        };
        return this.getWithParams<any>(`${_fornecedor}/recorrentes`, params);
    }

    obterProdutoOds(codigo: string) {
        return this.get<any>(`${codigo}`);
    }

    buscarProdutoIssComplementar() {
        return this.get<any>(`obter-produto-iss-complementar`);
    }
}
